

export const veoExamples = {
    title: 'AI 视频创作范例 — 关键帧控制与多图参考',
    sub:
      '探索先进模型的视频生成能力：关键帧控制、多图参考、原生音频。从图片到电影级视频，体验 AI 视频创作的无限可能。',
    originalImage: '原始图片',
    generatedVideo: 'AI 生成视频',
    pill: 'AI Video'
  };
